import { FC } from "react";
import { ToggleButton, ToggleButtonGroup, Tooltip, Typography, Button, Box } from "@mui/material";
import { styles } from "../stylesRightSidebar";
import LockSvg from "@/assets/svg/LockSvg";
import { RequireAuth } from "@/components/RequireAuth";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "@/store/store";
import { setView } from "@/store/slice/rightSidebarSlice";
import CustomLoader from "@/components/UI/CustomLoader/CustomLoader";

interface ToggleViewProps {
  premium: boolean;
  onPremiumClick?: () => void;
  subscriptionLoading: boolean;
}

const ToggleView: FC<ToggleViewProps> = ({ premium, onPremiumClick, subscriptionLoading }) => {
  const dispatch = useDispatch();
  const view = useSelector((state: RootState) => state.rightSidebar.view);

  return (
    <ToggleButtonGroup
      value={view}
      exclusive
      onChange={(_, value) => value && dispatch(setView(value))}
      sx={styles.toggleButtonGroup}
    >
      <ToggleButton disableRipple value="all" sx={styles.toggleButton}>
        All
      </ToggleButton>
      <Tooltip
        title={
          !premium && !subscriptionLoading ? (
            <Typography variant="body1" sx={{ lineHeight: "18px" }}>
              Available only for{" "}
              <Button onClick={onPremiumClick} sx={styles.toggleButtonTooltip}>
                Premium
              </Button>
            </Typography>
          ) : (
            ""
          )
        }
        placement="top"
        disableHoverListener={subscriptionLoading}
      >
        <span>
          <RequireAuth>
            <ToggleButton
              disableRipple
              value="follows"
              disabled={!premium}
              sx={styles.toggleButton}
            >
              My follows
              {subscriptionLoading ? (
                <Box>
                  <CustomLoader loading size={16} color="#000000ff" />
                </Box>
              ) : (
                !premium && <LockSvg height="16px" width="16px" />
              )}
            </ToggleButton>
          </RequireAuth>
        </span>
      </Tooltip>
    </ToggleButtonGroup>
  );
};

export default ToggleView;
